import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export interface BillPaymentLogEntry {
  id: string;
  bill_id: string;
  bill_line_id: string | null;
  action: string;
  line_description: string | null;
  line_amount: number;
  payment_amount: number;
  payment_method: string | null;
  payment_reference: string | null;
  payment_date: string | null;
  recorded_by: string | null;
  created_at: string;
}

export function useBillPaymentLog(billId: string | null) {
  return useQuery<BillPaymentLogEntry[]>({
    queryKey: ["bill_payment_log", billId],
    enabled: !!billId,
    queryFn: async () => {
      if (!billId) return [];
      const { data, error } = await supabase
        .from("bill_payment_log")
        .select("*")
        .eq("bill_id", billId)
        .order("created_at", { ascending: false });
      if (error) throw error;
      return (data ?? []) as unknown as BillPaymentLogEntry[];
    },
  });
}
